<template>
  <b-modal title="Lista de Equipamento" v-model="show" size="xl">
    <div id="listaDeEquipamentos">
      <b-row>
        <b-col cols="4"><b-form-checkbox> Orçamento Gerado </b-form-checkbox> </b-col>
        <b-col cols="4"><b-form-checkbox> Relatório Emitido </b-form-checkbox> </b-col>
        <b-col cols="4"><b-form-checkbox> Relatório Enviado </b-form-checkbox> </b-col>
      </b-row>
      <b-card no-body bg-variant="secondary" text-variant="white">
        <b-card-body class="text-center p-0 pt-3 pr-3">
          <b-form-group label="LISTA:" label-for="lista" label-cols-sm="1" label-align-sm="right">
            <b-form-input id="lista" />
          </b-form-group>

          <b-row>
            <b-col cols="6">
              <b-form-group
                label="CLIENTE:"
                label-for="cliente"
                label-cols-sm="2"
                label-align-sm="right"
              >
                <b-form-select>
                  <b-form-select-option
                    v-for="cliente of clienteStore.clientes"
                    v-bind:key="cliente.id"
                    :value="cliente"
                    >{{ cliente.nome }}
                  </b-form-select-option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label-cols-sm="2" label="DATA:" label-align-sm="right" label-for="data">
                <b-form-datepicker
                  id="data"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                ></b-form-datepicker>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <b-table
        bordered
        hover
        small
        head-variant="light"
        :items="lista"
        :fields="fields.equipamento_print"
      >
        <template #cell(servico)>
          <div>
            <b-form-textarea class="text-tabela" />
          </div>
        </template>
      </b-table>
    </div>
    <template #modal-footer>
      <b-button variant="primary" v-print="'#listaDeEquipamentos'">Imprimir</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import { useClienteStore } from "@/stores/ClienteStore";
import { storeToRefs } from "pinia";
import TableFields from "@/tools/TableFields";

export default {
  name: "ModalDeImpressaoDeListaEquipamento",

  data() {
    return {
      show: false,
      fields: new TableFields(),
      lista: [],
    };
  },

  methods: {
    call(lista) {
      this.show = !this.show;
      this.lista = lista;
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipamentoStore = useEquipamentoStore();
    const { getFilterEquipamentos } = storeToRefs(equipamentoStore);
    const clienteStore = useClienteStore();

    return {
      store,
      equipamentoStore,
      getFilterEquipamentos,
      clienteStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
